/** One content grid for every section: header, stats, nav, hero and page body. */
export const PAGE_MAX_WIDTH = "1440px";

export const PAGE_PX = { xs: "16px", sm: "24px", md: "32px" };
